import { render, staticRenderFns } from "./UHF-LS-50.vue?vue&type=template&id=99abb220&scoped=true&lang=pug"
import script from "./UHF-LS-50.vue?vue&type=script&lang=js"
export * from "./UHF-LS-50.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99abb220",
  null
  
)

export default component.exports